export var MatrixClientEventType;
(function (MatrixClientEventType) {
    MatrixClientEventType["INVITE"] = "invite";
    MatrixClientEventType["MESSAGE"] = "message";
})(MatrixClientEventType || (MatrixClientEventType = {}));
//# sourceMappingURL=MatrixClientEvent.js.map